import { Sparkles } from "lucide-react";
import React from "react";

import { BookmarkIcon } from "@/app/assets/icons/interface/interface.jsx";
import Spinner from "@/app/components/Spinner.jsx";
import { Button } from "@/app/components/ui/button.js";

import { ApplicationDetails, JobDetails } from "../utils/helpers";

interface JobActionButtonsProps {
	jobDetails: JobDetails;
	submitting: boolean;
	isUserLoggedIn: boolean;
	isOnProfilePage: boolean;
	applicationDetails: ApplicationDetails;
	explainerIsLoading: boolean;
	isInBasket: (jobId: string) => boolean;
	onSave: () => void;
	onApply: (link: string | null) => void;
	onFitCheckMe: () => void;
	onRoleExplainer: () => void;
	onNotRelevant: () => void;
}

export function JobActionButtons({
	jobDetails,
	submitting,
	isUserLoggedIn,
	isOnProfilePage,
	applicationDetails,
	explainerIsLoading,
	isInBasket,
	onSave,
	onApply,
	onFitCheckMe,
	onRoleExplainer,
	onNotRelevant,
}: JobActionButtonsProps) {
	return (
		<div className="flex items-center justify-between mb-8">
			<div className="flex items-center space-x-2">
				<button
					disabled={submitting}
					className="inline-flex items-center justify-center bg-gray-200 text-gray-700 h-9 rounded-lg hover:bg-gray-300 transition-colors text-sm font-inter w-[70px] relative overflow-hidden"
					onClick={onSave}
				>
					<span className="transition-all duration-300">{submitting ? "Saving..." : "Save"}</span>
					<span className="absolute inset-0 flex items-center justify-center transition-all duration-300 opacity-0 transform translate-y-8">
						<BookmarkIcon className="w-5 h-5" />
					</span>
				</button>
				<Button variant="tonal" onClick={() => onApply(applicationDetails.link)}>
					<span className="mr-1 group-hover:mr-3 transition-all duration-300">Apply</span>
					<span className="absolute right-4 opacity-0 transition-all duration-300 transform translate-x-2 group-hover:opacity-100 group-hover:translate-x-0">
						›
					</span>
				</Button>
			</div>
			<div className="flex gap-4">
				{isUserLoggedIn && (
					<Button onClick={onFitCheckMe} disabled={isOnProfilePage && !!jobDetails?._id && isInBasket(jobDetails._id)}>
						<Sparkles className="h-4 mr-1" />
						{isOnProfilePage
							? isInBasket(jobDetails?._id || "")
								? "Added to Basket"
								: "Add to FitCheck"
							: "FitCheckMe"}
					</Button>
				)}

				<Button onClick={onNotRelevant} variant="ghost">
					{submitting ? "Loading..." : "Not Relevant"}
				</Button>
			</div>
		</div>
	);
}
